export default __webpack_public_path__ + "static/media/pepsico-viverbem-white.a1364ecd.png";